import type {
  Reasons,
  ActionType,
  ParticipantType,
} from 'src/types/scheduler/reasons';
import type {Dispatch, ThunkAction} from 'src/reducers';

import * as reduxApi from 'src/utils/redux-api-v2';
import {camel, snake} from 'src/utils/camel-snake';


export const SET_REASONS = 'SET_REASONS';

export type SchedulerReasonActions = SetReasons;

export type SetReasons = {
  type: typeof SET_REASONS;
  payload: Reasons;
};

export const setReasons = (payload: Reasons): SetReasons => ({
  type: SET_REASONS,
  payload,
});

export const fetchReasons = (): ThunkAction => async (dispatch: Dispatch) => {
  try {
    const reasons: Reasons =
      (await dispatch(reduxApi.get('scheduler/event-action-reasons'))) || [];
    dispatch(setReasons(camel(reasons)));
  } catch (error: any) {
    throw error;
  }
};

export type SaveReasonsPayload = {
  create: Array<{
    reason: string;
    actionType: ActionType;
    participantType: ParticipantType;
  }>;
  update: Array<{
    id: string;
    reason: string;
  }>;
  delete: string[];
};

export const saveReasons =
  (payload: SaveReasonsPayload): ThunkAction<void> =>
  async (dispatch: Dispatch) => {
    try {
      const reasons: Reasons = await dispatch(
        reduxApi.post('scheduler/event-action-reasons', snake(payload)),
      );
      dispatch(setReasons(camel(reasons)));
    } catch (error: any) {
      throw error;
    }
  };
